import { useState } from 'react';
import {
  JobPostingSortableField,
  JobPostingStatus,
  useGetJobPostings,
} from '~/domain/PermanentJobs';
import { IFilterFormData } from './components';
import { TSortValue } from '~/commonComponents';

const DEFAULT_SORTING = {
  direction: 'DESC',
  field: JobPostingSortableField.PublishedAt,
};

export const useManageJobs = () => {
  const [formFilters, setFormFilters] = useState<IFilterFormData>({
    officeId: '',
    profession: 'all',
    status: JobPostingStatus.Active,
  });
  const [formSorting, setFormSorting] = useState<TSortValue>(DEFAULT_SORTING);
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isInitialLoading, isLoading, pagination, statistics } = useGetJobPostings({
    officeId: formFilters.officeId,
    orderBy: formSorting.field as JobPostingSortableField,
    orderDirection: formSorting.direction,
    page: currentPage,
    professionType: formFilters.profession === 'all' ? undefined : formFilters.profession,
    status: formFilters.status,
    subProfessionType: formFilters.subProfession,
  });

  const handleSetFormSorting = (value: TSortValue | undefined) => {
    setFormSorting(value === undefined ? DEFAULT_SORTING : value);
  };

  return {
    data: data,
    forms: {
      filters: formFilters,
      sorting: formSorting,
    },
    isInitialLoading,
    isLoading,
    methods: {
      setCurrentPage,
      setFormFilters,
      setFormSorting: handleSetFormSorting,
    },
    pagination: {
      currentPage: currentPage,
      totalPages: pagination.totalPages,
    },
    statistics,
  };
};
